/**
 * A short two-tone chime synthesized with the Web Audio API (no audio file).
 * Browsers only allow sound after the user interacted with the page, so the
 * audio context is unlocked on the first pointer or key press.
 */
let ctx: AudioContext | null = null

function context(): AudioContext | null {
  if (typeof window === 'undefined' || !('AudioContext' in window)) return null
  ctx ??= new AudioContext()

  return ctx
}

export function unlockNotificationSound() {
  const unlock = () => {
    void context()
      ?.resume()
      .catch(() => undefined)
    window.removeEventListener('pointerdown', unlock)
    window.removeEventListener('keydown', unlock)
  }

  window.addEventListener('pointerdown', unlock)
  window.addEventListener('keydown', unlock)

  return unlock
}

export function playNotificationSound() {
  const audio = context()

  if (!audio || audio.state !== 'running') return
  const start = audio.currentTime + 0.01

  for (const [i, freq] of [880, 1320].entries()) {
    const osc = audio.createOscillator()
    const gain = audio.createGain()
    const t = start + i * 0.11

    osc.type = 'sine'
    osc.frequency.value = freq
    gain.gain.setValueAtTime(0, t)
    gain.gain.linearRampToValueAtTime(0.07, t + 0.015)
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.16)
    osc.connect(gain).connect(audio.destination)
    osc.start(t)
    osc.stop(t + 0.18)
  }
}
